/*************************************************/
/* INTERSECTION OBSERVATION                      */
/*************************************************/

export function intersectionObservation() {
    const activeClass = 'in-view',
        targetsClasses = [".video-item__player"],
        options = {
            rootMargin: '200px'
        };
    const init = function () {
        let targets = [];
        for (var i = 0; i < targetsClasses.length; i++) {
            var targetElements = document.querySelectorAll(targetsClasses[i]);
            if (targetElements != null) {
                targets.push(...targetElements);
            }
        }
        if ('IntersectionObserver' in window) {
            function handleIntersection(entries) {
                entries.map((entry) => {
                    if (entry.isIntersecting) {
                        if (entry.target.dataset.autoplay) {
                            entry.target.click();
                        } else {
                            entry.target.classList.add(entry.target.classList[0] + "--" + activeClass);
                        }
                        observer.unobserve(entry.target);
                    }
                });
            }
            const observer = new IntersectionObserver(handleIntersection, options);
            targets.forEach(target => observer.observe(target));
        } else {
            targets.forEach(target => {
                target.classList.add(target.classList[0] + "--" + activeClass);
            });
        }
    };

    init();
}